<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-12">
        <div class="card">
          <div class="ribbon-wrapper card">
          <div class="card-body">
            <div class="ribbon ribbon-clip ribbon-warning">Edit Profile</div>

            <div *ngIf="currentAccount.status == 1">
              <div class="col-lg-12 col-md-12 col-12 f-w-700 text-center btn-success"><h5><span>Account is active</span></h5></div>
            </div>
            <div *ngIf="currentAccount.status == 2">
              <div class="col-lg-12 col-md-12 col-12 f-w-700 text-center btn-danger"><h5><span>Account is locked</span></h5></div>
            </div>
            <div *ngIf="currentAccount.status == 3">
              <div class="col-lg-12 col-md-12 col-12 f-w-700 text-center btn-warning"><h5><span>Account is registered but not Activated yet</span></h5></div>
            </div>
            <div *ngIf="currentAccount.status == 4">
              <div class="col-lg-12 col-md-12 col-12 f-w-700 text-center btn-warning"><h5><span>Account is active but change password is required during next login</span></h5></div>
            </div>
            <div class="row mb-2">
              <div class="media">
                <img class="img-70 rounded-circle" alt="" src="{{urlImage}}">
                <div class="media-body align-self-center">
                  <h3 >&nbsp;{{profileForm.value['firstName']}} {{profileForm.value['lastName']}}</h3>
                </div>
              </div>
            </div>

            <br>

            <div class="form-group">
              <label class="control-label" for="notes">Send info to account by email</label>
              <textarea rows="3" class="form-control" placeholder="enter info to send.." [(ngModel)]="currentAccountMessage.messageToSent"></textarea>
            </div>

            <div class="btn-showcase">
              <button class="btn btn-sm btn-pill btn-primary" type="button" placement="top"
                        ngbTooltip="send message to account" (click)="onSend()" >Send</button>
            </div>
          </div>
          </div>
        </div>
      </div>

      <div class="col-lg-8 col-md-8 col-12">
        <div class="card">
          <div class="card-header">
            <h5>Details</h5>
          </div>
          <div class="card-body">
            <form [formGroup]="profileForm" class="ngx-form" novalidate>
              <div class="row">
                <div class="col-lg-2 col-md-4 col-12">
                  <div class="form-group">
                    <label class="control-label" for="username">Username</label>
                    <input type="text" formControlName="userName" class="form-control" placeholder="enter user name..">
                    <div *ngIf="profileForm.controls['userName'].invalid && (profileForm.controls['userName'].dirty || profileForm.controls['userName'].touched)"
                        class="alert">
                        <div *ngIf="profileForm.controls['userName'].errors?.['required']">
                            User name is required.
                        </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-12">
                  <div class="form-group">
                    <label class="control-label" for="firstname">First Name</label>
                    <input type="text" formControlName="firstName" class="form-control" placeholder="enter first name.." >
                    <div *ngIf="profileForm.controls['firstName'].invalid && (profileForm.controls['firstName'].dirty || profileForm.controls['firstName'].touched)"
                        class="alert">
                        <div *ngIf="profileForm.controls['firstName'].errors?.['required']">
                            First Name is required.
                        </div>
                        <div *ngIf="profileForm.controls['firstName'].errors?.['pattern']">
                            Number is not allowed!
                        </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-12">
                  <div class="form-group">
                    <label class="control-label" for="lastname">Last Name</label>
                    <input type="text" formControlName="lastName" class="form-control" placeholder="enter last name.." >
                    <div *ngIf="profileForm.controls['lastName'].invalid && (profileForm.controls['lastName'].dirty || profileForm.controls['lastName'].touched)"
                        class="alert">
                        <div *ngIf="profileForm.controls['lastName'].errors?.['required']">
                            Last Name is required.
                        </div>
                        <div *ngIf="profileForm.controls['lastName'].errors?.['pattern']">
                            Number is not allowed!
                        </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-12 col-12">
                  <div class="form-group">
                    <label class="control-label" for="email">Email</label>
                    <input type="email" formControlName="email" class="form-control" autocomplete="off"
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" [email]="true" required="required" placeholder="enter email.." >
                    <div
                      *ngIf="profileForm.controls['email'].invalid && (profileForm.controls['email'].dirty || profileForm.controls['email'].touched)"
                      class="alert">
                      <div *ngIf="profileForm.controls['email'].errors?.['pattern']">
                        Email is required and format should be <i>john@doe.com</i>
                      </div>
                      <div *ngIf="profileForm.controls['email'].errors?.['required']">Email is required.</div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-12 col-12">
                  <div class="form-group">
                    <label class="control-label" for="roles">Roles</label>
                        <div class="form-group m-checkbox-inline mb-0 ml-1">
                          <div class="checkbox checkbox-danger">
                            <input id="checkAdmin" formControlName="checkAdmin" type="checkbox" >
                            <label class="mb-0" for="checkAdmin">Admin</label>
                          </div>
                          <div class="checkbox checkbox-primary">
                            <input id="checkPublisher" formControlName="checkPublisher" type="checkbox" (change)="setPublisher($event)">
                            <label class="mb-0" for="checkPublisher">Publisher</label>
                          </div>
                        </div>
                  </div>
                </div>

                <div class="col-lg-5 col-md-6 col-12">
                  <div class="form-group">
                    <label class="control-label" for="company">Company</label>
                    <input type="text" formControlName="company" class="form-control" placeholder="enter company.." >
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 col-12">
                  <div class="form-group">
                    <label class="control-label" for="company">TAX/VAT ID</label>
                    <input type="text" formControlName="tax" class="form-control" placeholder="enter TAX..">
                  </div>
                </div>

                <div class="col-lg-6 col-md-12 col-12">
                  <div class="form-group">
                    <label>Address</label>
                    <input type="text" formControlName="street" class="form-control" placeholder="enter street & number.." >
                    <div *ngIf="profileForm.controls['street'].invalid && (profileForm.controls['street'].dirty || profileForm.controls['street'].touched)"
                      class="alert">
                      <div *ngIf="profileForm.controls['street'].errors?.['required']">
                        Street name and number is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 col-5">
                  <div class="form-group">
                    <label>Zip/Postal code</label>
                    <input type="text" formControlName="zip" class="form-control" placeholder="Zip/Postal.." >
                    <div *ngIf="profileForm.controls['zip'].invalid && (profileForm.controls['zip'].dirty || profileForm.controls['zip'].touched)"
                      class="alert">
                      <div *ngIf="profileForm.controls['zip'].errors?.['required']">
                        Zip/Postal code number is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-8 col-7">
                  <div class="form-group">
                    <label>City</label>
                    <input type="text" formControlName="cityName" class="form-control" placeholder="enter city.." >
                    <div *ngIf="profileForm.controls['cityName'].invalid && (profileForm.controls['cityName'].dirty || profileForm.controls['cityName'].touched)"
                      class="alert">
                      <div *ngIf="profileForm.controls['cityName'].errors?.['required']">
                        City name is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 col-md-5 col-12">
                  <div class="form-group">
                    <i class="flag-icon flag-icon-{{flag | lowercase}}"></i>&nbsp;
                    <label>Country</label>
                    <select id="country" class="form-select" formControlName="country" (change)="setFlag($event)">
                      <option [ngValue]="null" selected disabled>country..</option>
                      <option *ngFor="let country of countryData" [value]="country.id">{{country.name}}</option>
                    </select>
                    <div *ngIf="profileForm.controls['country'].invalid && (profileForm.controls['country'].dirty || profileForm.controls['country'].touched)"
                      class="alert">
                      <div *ngIf="profileForm.controls['country'].errors?.['required']">
                        Country name is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-4 col-7" *ngIf="show">
                  <div class="form-group">
                    <label>Payout term</label>
                    <select class="form-select btn-square" formControlName="payterm" id="payterm">
                      <option [ngValue]="null" selected disabled>term..</option>
                      <option value="1" >every week</option>
                      <option value="2" >biweekly</option>
                      <option value="3" >every three weeks</option>
                      <option value="4" >every four weeks</option>
                    </select>
                    <div *ngIf="profileForm.controls['payterm'].invalid && (profileForm.controls['payterm'].dirty || profileForm.controls['payterm'].touched)"
                      class="alert">
                      <div *ngIf="profileForm.controls['payterm'].errors?.['required']">
                        Payout term is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-2 col-3" *ngIf="show">
                  <div class="form-group">
                    <label>Rate %</label>
                    <input type="number" min="0" max="1" step="0.05" id="rate" formControlName="rate" class="form-control" >
                    <div *ngIf="profileForm.controls['rate'].invalid && (profileForm.controls['rate'].dirty || profileForm.controls['rate'].touched)"
                    class="alert">
                    <div *ngIf="profileForm.controls['rate'].errors?.['required']">
                      Rate number is required.
                    </div>
                  </div>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12 col-12">
                  <div class="form-group mb-0">
                    <label class="control-label" for="notes">About me</label>
                    <textarea rows="3" formControlName="notes" class="form-control" placeholder="enter info if you like.." ></textarea>
                  </div>
                </div>

                <div class="card-footer btn-showcase">
                  <button class="btn btn-sm btn-pill btn-primary btn-submit" type="submit" ngbTooltip="return to publishers"
                  (click)="onCancel()">Cancel</button>
                  <button class="btn btn-sm btn-pill btn-primary btn-submit" type="submit" ngbTooltip="create new profile" [disabled]="!profileForm.valid"
                  (click)="onUpdate()">Update</button>
                  <button class="btn btn-sm btn-pill btn-primary btn-submit" type="submit" ngbTooltip="delete publisher"
                  (click)="onDelete()">Delete</button>
                  <ng-container *ngIf="currentAccount.status == 3; else active">
                    <button class="btn btn-sm btn-pill btn-success" type="button" placement="top"
                              ngbTooltip="activate account" (click)="onRegister()" >Activate</button>
                  </ng-container>
                  <ng-template #active>
                    <button class="btn btn-sm btn-pill btn-primary" type="button" placement="top"
                              ngbTooltip="(un)lock account" (click)="onLock()" *ngIf="currentAccount.status == 1 || currentAccount.status == 4" >Lock</button>
                    <button class="btn btn-sm btn-pill btn-danger" type="button" placement="top"
                              ngbTooltip="(un)lock account" (click)="onLock()" *ngIf="currentAccount.status == 2">unLock</button>
                    <button class="btn btn-sm btn-pill btn-primary" type="button" placement="top"
                              ngbTooltip="send request for change password" (click)="onPass()" *ngIf="currentAccount.status != 4 && currentAccount.status !=2">Change password</button>
                  </ng-template>
                </div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
</div>
<!-- Container-fluid Ends-->
